/** VideoStartupStates keeps the states used internal video startup state control */ export var VideoStartupStates = /*#__PURE__*/ function(VideoStartupStates) {
    VideoStartupStates["Uninitialised"] = "Uninitialised";
    VideoStartupStates["Initialised"] = "Initialised";
    VideoStartupStates["VideoProviderCalled"] = "VideoProviderCalled";
    VideoStartupStates["AdvertsInitialised"] = "AdvertsInitialised";
    VideoStartupStates["VamCalled"] = "VamCalled";
    VideoStartupStates["AdsBootstrapped"] = "AdsBootstrapped";
    VideoStartupStates["AdsInsertionCalled"] = "AdsInsertionCalled";
    VideoStartupStates["EngineStarted"] = "EngineStarted";
    VideoStartupStates["Discarded"] = "Discarded";
    VideoStartupStates["Destroyed"] = "Destroyed";
    VideoStartupStates["Retried"] = "Retried";
    return VideoStartupStates;
}({});

//# sourceMappingURL=video-startup.enums.js.map